module.exports = __webpack_public_path__ + "static/img/image10.59962e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image10.png
// module id = hhjL
// module chunks = 0